(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

      this.setHeaderHeight =
        this.setHeaderHeight.bind(this);

    }

    connectedCallback() {

      this.header =
        document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always'
        ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearches =
        this.querySelectorAll('predictive-search');

      this.onScrollHandler =
        this.onScroll.bind(this);

      this.hideHeaderOnScrollUp =
        () => (this.preventReveal = true);

      this.setHeaderHeight();

      window.addEventListener(
        'resize',
        this.setHeaderHeight
      );

      if (this.headerIsAlwaysSticky) {

        this.header.classList.add(
          'shopify-section-header-sticky'
        );

      }

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();

    }

    setHeaderHeight() {

      if (!this.header) {
        return;
      }

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }

    disconnectedCallback() {

      window.removeEventListener(
        'resize',
        this.setHeaderHeight
      );

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }

    createObserver() {

      const observer =
        new IntersectionObserver(
          (entries, observerInstance) => {

            this.headerBounds =
              entries[0].intersectionRect;

            observerInstance.disconnect();

          }
        );

      observer.observe(this.header);

    }

    onScroll() {

      const scrollTop =
        window.pageYOffset
        ||
        document.documentElement.scrollTop;

      if (
        [...this.predictiveSearches].some(
          (predictiveSearch) =>
            predictiveSearch.isOpen
        )
      ) {

        return;

      }

      if (
        scrollTop > this.currentScrollTop
        &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          !this.headerIsAlwaysSticky
        ) {

          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      }

      else if (
        scrollTop < this.currentScrollTop
        &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          !this.headerIsAlwaysSticky
        ) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        }

      }

      else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.header.classList.remove(
          'scrolled-past-header'
        );

        if (
          !this.headerIsAlwaysSticky
        ) {

          requestAnimationFrame(
            this.reset.bind(this)
          );

        }

      }

      this.currentScrollTop = scrollTop;

    }

    hide() {

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

    }

    reveal() {

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }

    reset() {

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }

  }

  if (
    !customElements.get('sticky-header')
  ) {

    customElements.define(
      'sticky-header',
      StickyHeader
    );

  }


  } catch(e) { console.error(e); }
})();
})();
